import styles from "./ProductCardBody.module.scss";

import { EnergyType } from "@/types/data";
import FlowerIcon from "@/images/icons/brand/flower.svg";
import clsx from "clsx";

interface ProductCardBodyProps {
	list: string[]
	icons: {
		url: string;
		label: string;
	}[]
	energy: EnergyType;
}

export const ProductCardBody = ({ list, icons, energy }: ProductCardBodyProps) => {
	const isGas = energy === "gas";

	return (
		<div className={clsx(styles["product-body"])}>
			{list && (
				<ul className={styles["product-body__description-list"]}>
					{list.map(item => (
						<li
							className={styles["product-body__description"]}
							key={item}
						>
							<FlowerIcon />
							<span>{item}</span>
						</li>
					))}
				</ul>
			)}
			<div
				className={clsx(styles["product-body__icons"], isGas && styles["product-body__icons--gas"])}
			>
				 {icons.map((icon, i) => ( 
					<ProductIconItem
						key={i}
						url={icon.url}
						label={icon.label}
					/>
				))} 
			</div>
		</div>
	);
};


const ProductIconItem =  ({ url, label }: { url: string, label: string }) => {
	return (
		<div className={styles["product-icon"]}>
			<img
				className={styles["product-icon__image"]}
				alt=""
				key={url}
				src={url}
				width={80}
				height={80}
			/>
			<span className={styles["product-icon__label"]}>{label}</span>
		</div>
	);
};
